import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENU',
    isTitle: true
  }, {
    id: 2,
    label: 'Dashboard',
    icon: 'layout-dashboard',
    link: '/dashboard',
  }, {
    id: 3,
    label: 'Store Products',
    icon: 'package',
    link: '/products',
    badge: {
      variant: 'bg-info',
      text: '0',
      hideIfZero: true
    }
  }, {
    id: 10,
    label: 'Sync History',
    icon: 'clock',
    link: '/reports/feed-sync-history',
  }, 
  // {
  //   id: 5,
  //   label: 'Reports',
  //   icon: 'ri-pie-chart-line',
  //   link: '/reports',
  // },
   {
    id: 6,
    label: 'Feeds',
    icon: 'rss',
    link: '/feeds',
  },  {
    id: 9,
    label: 'Stores',
    icon: 'store',
    link: '/shops',
  }, {
    id: 7,
    label: 'Settings',
    icon: 'settings',
    link: '/account',
  }
  // , {
  //   id: 8,
  //   label: 'Documentation',
  //   icon: 'ri-book-2-line',
  //   link: '/documentation',
  // }
];